import React from "react";
import './cards.scss';

export default class Cards extends React.Component {
    static defaultProps = {
        columns: 3
    }

    render() {
        const columns = parseInt(this.props.columns);
        const cardClassName = isNaN(columns) ? this.props.columns : this.getColumnClassName(columns);
        const rowClassName = !isNaN(columns) && this.props.children.length < columns ? ' pubhub-section-frame-center-row' : '';

        const cardList = this.props.children ? this.props.children.map((i, idx) => this.renderCard(i, idx, cardClassName)) : null;

        return (
            <div className='pubhub-section-frame-cards'>
                <div className='container'>
                    <div className={'row pubhub-section-frame-card-row' + rowClassName}>
                        {cardList}
                    </div>
                </div>
            </div>
        );
    }

    renderCard(child, idx, className) {
        return (
            <div key={idx} className={'col-12 pubhub-section-frame-card-col ' + className}>
                <div className='pubhub-section-frame-card'>
                    {child}
                </div>
            </div>
        );
    }

    getColumnClassName(cols) {
        if (cols == 1) {
            return '';
        }
        if (cols == 2) {
            return 'col-lg-6';
        }
        if (cols == 3) {
            return 'col-lg-4 col-md-6';
        }
        return 'col-xl-3 col-lg-4 col-md-6';
    }
}